import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import DropdownSelector from "../../../atoms/Common/DropdownSelector";
import { FastField, useFormikContext } from "formik";
import { getUserWarehousesByUserId } from "../../../api/userWarehouses";
import { useUser } from "../../../context/UserContext";
import MyDatePicker from "../../../atoms/Common/MyDatePicker";

interface FormValues {
  inbound: {
    companyId: number | null;
    description: string;
    warehouseId: number | null;
    isNational: boolean;
    inboundDate: any;
  };
  inboundItems: Array<{
    description: string;
    deliveryNo: number;
    quantityDelivered: number;
    weight: number;
    productId: number | null;
    productCategoryId: number | null;
  }>;
}

interface InboundHeaderNoPOProps {
  companyId: number;
}

const InboundHeaderNoPO: React.FC<InboundHeaderNoPOProps> = ({
  companyId,
}) => {
  const { userData } = useUser();
  const { values, setFieldValue } = useFormikContext<FormValues>();

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Nota de entrada
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FastField
            name="inbound.warehouseId"
            as={DropdownSelector}
            label="Almacén"
            fetchFunction={getUserWarehousesByUserId}
            fetchParams={userData.id}
            optionLabel={"warehouse.name"}
            margin="normal"
            fullWidth
            value={values.inbound.warehouseId}
            keyField={"warehouseId"}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={values.inbound.isNational}
                onChange={(e) => setFieldValue("inbound.isNational", e.target.checked)}
                color="primary"
              />
            }
            label="Es Nacional"
          />
        </Grid>
        <Grid item xs={12}>
          <MyDatePicker
            label="Fecha de Ingreso"
            value={values.inbound.inboundDate}
            onChange={(date) => setFieldValue("inbound.inboundDate", date)}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField
            name="inbound.description"
            as={TextField}
            label="Observaciones "
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            margin="normal"
            value={values.inbound.description}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InboundHeaderNoPO;
